import { NgModule } from "@angular/core";
// import { LinkifyPipe } from "./linkify.pipe";
import { Linkifier } from "src/app/models/linkifier";
import { LinkifyPipe } from "./linkify.pipe";

@NgModule({
    declarations: [LinkifyPipe],
    exports: [LinkifyPipe],
    providers: [Linkifier],
})
export class LinkifyModule {}